<template>
    <div class="edit-personal-info">
        <div class="edit-container">
            <el-page-header class="edit-title" @back="goBack" content="修改个人信息">
            </el-page-header>
            <!-- 修改标题样式，添加左侧蓝色竖线 -->
            <!-- <h2 class="edit-title">
                <span class="title-line"></span>
                修改个人信息
            </h2> -->
            <el-form ref="form" :model="form" label-width="50px" class="edit-form">
                <!-- 头像上传 -->
                <el-form-item label="头像" style="display: flex;align-items: center;">
                    <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
                        :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                        <img :src="form.avatar" class="avatar">
                        <!-- 相机图标覆盖层 -->
                        <div class="camera-box">
                            <img src="@/assets/images/52.png" class="camera-icon">
                        </div>
                    </el-upload>
                </el-form-item>
                <!-- 昵称输入 -->
                <el-form-item label="昵称" required style="display: flex;align-items: center;">
                    <el-input v-model="form.nickname" placeholder="请输入昵称"></el-input>
                </el-form-item>
                <!-- 完成按钮 -->
                <el-form-item>
                    <el-button type="primary" @click="handleSubmit" class="complete-btn">完成</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EditPersonalInfo',
    data() {
        return {
            form: {
                avatar: '', // 默认头像
                nickname: '' // 默认昵称
            }
        }
    },
    methods: {
        // 跳转到个人信息页面
        goBack() {
            this.$parent.currentComponent = 'PersonalInfo'
        },
        // 头像上传成功处理
        handleAvatarSuccess(res, file) {
            this.form.avatar = URL.createObjectURL(file.raw)
        },
        // 头像上传前验证
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
            const isLt2M = file.size / 1024 / 1024 < 2

            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!')
            }
            return isJPG && isLt2M
        },
        // 提交表单
        handleSubmit() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 这里可以添加实际的提交逻辑
                    this.$message.success('修改成功!')
                    this.$parent.currentComponent = 'PersonalInfo'
                } else {
                    return false
                }
            })
        }
    }
}
</script>

<style scoped>
.edit-personal-info {
    background-color: #ffffff;

}

.edit-container {
    /* margin-top: 20px; */
    border: none;
    border-radius: 0;
    padding: 0;
}

/* 标题样式 - 添加左侧蓝色竖线 */
.edit-title {
    font-size: 18px;
    font-weight: 600;
    color: #333333;
    margin-bottom: 40px;
    padding-bottom: 15px;
    border-bottom: none;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #EEEEEE;
}

.title-line {
    display: inline-block;
    width: 4px;
    height: 20px;
    background-color: #286CED;
    margin-right: 10px;
}

/* 表单样式 */
.edit-form {
    max-width: 400px;
}

.el-form-item {
    margin-bottom: 40px;
}

.el-form-item__label {
    font-weight: 500;
    color: #333333;
    padding-right: 10px;
}

/* 头像上传样式 */
.avatar-uploader {
    position: relative;
    width: 100px;
    height: 100px;
}

.avatar-uploader .el-upload {
    border: none;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 100px;
}

.avatar-uploader .el-upload:hover {
    border-color: transparent;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
    background-color: #f5f7fa;
    border-radius: 50%;
}

.avatar {
    width: 100px;
    height: 100px;
    display: block;
    border-radius: 50%;
    object-fit: cover;
}

.camera-box {
    position: absolute;
    width: 100px;
    height: 100px;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
}

/* 相机图标样式 */
.camera-icon {
    width: 30px;
    height: 30px;
}

/* 完成按钮样式 */
.complete-btn {
    width: 156px;
    height: 40px;
    background-color: #286CED;
    border-color: #286CED;
    border-radius: 4px;
    font-size: 14px;
}

::v-deep .el-form-item__content {
    margin-left: 0 !important;
}
</style>